import flatMap from 'lodash/flatMap';
import env from './env';
import { countries } from '../components/i18n';

const { TOOSA_URL, TOOSA_URL_SE, TOOSA_URL_DEMO, TOOSA_URL_UK } = env;

const fiMapping = {
  URL: TOOSA_URL,
  TITLE: 'Someturva',
  COUNTRY_PHONE_CODE: '+358',
};

const seMapping = {
  URL: TOOSA_URL_SE,
  TITLE: 'SomeBuddy',
  COUNTRY_PHONE_CODE: '+46',
};

const demoMapping = {
  URL: TOOSA_URL_DEMO,
  TITLE: 'SomeBuddy Demo',
  COUNTRY_PHONE_CODE: '+44', // UK phone code for demo
};

const ukMapping = {
  URL: TOOSA_URL_UK,
  TITLE: 'SomeBuddy',
  COUNTRY_PHONE_CODE: '+44',
};

const mappingsByLocale = {
  'fi-FI': fiMapping,
  'sv-FI': fiMapping,
  'sv-SE': seMapping,
  'en-FI': fiMapping,
  'fi-SE': seMapping,
  'en-SE': seMapping,
  'en-DEMO': demoMapping,
  'en-GB': ukMapping,
};

const getLocaleMapping = (locale = 'fi-FI') =>
  mappingsByLocale[locale] || fiMapping;

export const allowedLocales: string[] = [
  ...flatMap(countries, (country) => country.languages.map((_) => _.locale)),
  'en-DEMO', // Demo locale not tied to a specific country
];
export const allowedCountries: string[] = [
  'GLOBAL',
  ...flatMap(countries, (country) => country.shortname),
];

export const getToosaUrlByLocale = (locale): string => {
  const url = getLocaleMapping(locale).URL;
  if (!url) {
    // Fail loud rather than silently building a literal "undefined/login"
    // URL that browsers misinterpret as a relative path and infinite-loop on.
    // Caller sees a real error in logs; admin/operator can fix the env config.
    throw new Error(
      `TOOSA URL for locale "${locale}" is not configured. Check that the corresponding TOOSA_URL_* env var is set.`,
    );
  }
  return url;
};

// With no usable locale getRedirect sends a visitor to the /country picker;
// only that, /locale, and the pages exempt from its locale gate (the UK
// pre-auth pages, /maintenance, /login, /logout…) render without one. Both
// brands reach them — a Finnish first visit, and a link-preview crawler that
// drops the cookies the /school deep link sets — and the request alone can't
// tell them apart, so the title names both rather than guessing one.
const NO_LOCALE_TITLE = `${seMapping.TITLE} | ${fiMapping.TITLE}`;

export const getTitleByLocale = (locale): string =>
  mappingsByLocale[locale]?.TITLE ?? NO_LOCALE_TITLE;

export const getCountryPhoneCodeByLocale = (locale) =>
  getLocaleMapping(locale).COUNTRY_PHONE_CODE;

export const getLocaleForHTML = (user): string =>
  user ? JSON.parse(user).locale : null;
